import { render } from "./Aid.vue?vue&type=template&id=2f3447c5&scoped=true"
import script from "./Aid.vue?vue&type=script&lang=js"
export * from "./Aid.vue?vue&type=script&lang=js"

import "./Aid.vue?vue&type=style&index=0&id=2f3447c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3447c5"]])

export default __exports__